<template>
    <div class="pa-5 pt-2 pb-2" v-if="activeExportInvoice && activeExportInvoice.transports">
        <div v-for="(item, index) in activeExportInvoice.transports" :key="`export_invoice_transport_${item.id}`">
            <v-row no-gutters>
                <v-col class="col-item row-title" cols="3">{{ "Delivery date" | t }}</v-col>
                <v-col class="col-item" cols="6">
                    {{ item.delivery_date ? formatDate(item.delivery_date) : "-" }}
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col class="col-item row-title" cols="3">{{ "Terms of delivery" | t }}</v-col>
                <v-col class="col-item" cols="6">
                    {{ item.terms_of_delivery ? item.terms_of_delivery : "-" }}
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col class="col-item row-title" cols="3">{{ "Cargo type" | t }}</v-col>
                <v-col class="col-item" cols="6">
                    {{ item.cargo_type ? getCargoType(item.cargo_type) : "-" }}
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col class="col-item row-title" cols="3">{{ "Carrier company" | t }}</v-col>
                <v-col class="col-item" cols="6">
                    {{ item.carrier_company ? item.carrier_company : "-" }}
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col class="col-item row-title" cols="3">{{ "Additional terms" | t }}</v-col>
                <v-col class="col-item" cols="6">
                    {{ item.additional_terms ? item.additional_terms : "-" }}
                </v-col>
            </v-row>
            <v-divider class="my-2" />
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";

export default {
    name: "transport-tab",
    data() {
        return {
            cargoTypeItems: [
                {
                    title: "20”",
                    value: "20"
                },
                {
                    title: "20” reefer",
                    value: "20_reefer"
                },
                {
                    title: "40”",
                    value: "40"
                },
                {
                    title: "40” reefer",
                    value: "40_reefer"
                },
                {
                    title: "Rekka 2,7m kõrge",
                    value: "truck_height_2.7m"
                },
                {
                    title: "Rekka 2-2,5m kõrge",
                    value: "truck_height_2-2.5m"
                }
            ]
        };
    },
    computed: {
        ...mapState("ExportSaleInvoiceStore", ["activeExportInvoice"])
    },
    methods: {
        getCargoType(cargoType) {
            const item = this.cargoTypeItems.find(ct => ct.value === cargoType);

            if (item) {
                return item.title;
            }

            return cargoType;
        },
        formatDate(value) {
            if (value) {
                return moment(value, "YYYY-MM-DD").format("DD.MM.YYYY");
            }

            return "-";
        }
    }
};
</script>

<style scoped>
.row-title {
    color: gray;
}

.col-item {
    padding-top: 2px;
    padding-bottom: 2px;
}
</style>
